import React from 'react'

const DisplayTour = ({ tour, compact = false }) => {
    const [activeIndex, setActiveIndex] = React.useState(0);
    
    const imageUrls = tour.image_urls ? tour.image_urls.split(",").filter(url => url.trim()) : [];
    
    const updateActiveIndex = (increment) => {
        if (imageUrls.length === 0) return;
        const maxIndex = imageUrls.length - 1;
        let newIndex = activeIndex + increment;

        if (newIndex < 0) {
            newIndex = maxIndex;
        } else if (newIndex > maxIndex) {
            newIndex = 0;
        }

        setActiveIndex(newIndex);
    };

    if (compact) {
        return (
            <div className="tour-card">
                {imageUrls.length > 0 && (
                    <div className="tour-card-image">
                        <img 
                            src={imageUrls[0]} 
                            alt={tour.title}
                            style={{ 
                                width: '100%', 
                                height: '200px', 
                                objectFit: 'cover' 
                            }}
                        />
                    </div>
                )}
                <div className="p-3">
                    <h5 className="mb-2">{tour.title}</h5>
                    <p className="text-muted small mb-2" style={{ 
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical'
                    }}>
                        {tour.description}
                    </p>
                    <div className="d-flex justify-content-between align-items-center">
                        <span className="text-muted small">{tour.duration_in_hours} hrs</span>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="tour-display">
            {imageUrls.length > 0 && (
                <div className="tour-carousel mb-4">
                    <div id="imageCarousel" className="carousel slide" data-bs-ride="carousel">
                        <div className="carousel-inner carousel-background rounded">
                            {imageUrls.map((imageUrl, index) => (
                                <div 
                                    className={index === activeIndex ? "carousel-item active" : "carousel-item"} 
                                    key={index}
                                >
                                    <img 
                                        src={imageUrl} 
                                        className="d-block w-100"
                                        style={{ maxHeight: '400px', objectFit: 'contain' }}
                                        alt={`${tour.title} - ${index + 1}`} 
                                    />
                                </div>
                            ))}
                        </div>
                        {imageUrls.length > 1 && (
                            <>
                                <button 
                                    className="carousel-control-prev" 
                                    type="button" 
                                    onClick={() => updateActiveIndex(-1)}
                                >
                                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Previous</span>
                                </button>
                                <button 
                                    className="carousel-control-next" 
                                    type="button" 
                                    onClick={() => updateActiveIndex(1)}
                                >
                                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                    <span className="visually-hidden">Next</span>
                                </button>
                            </>
                        )}
                    </div>
                </div>
            )}
            
            <div className="tour-info">
                <h1 className="mb-3">{tour.title}</h1>
                <p className="text-muted lead">{tour.description}</p>
                
                <div className="tour-details d-flex flex-wrap gap-4 my-4">
                    <div className="detail-item">
                        <i className="bi bi-clock me-2"></i>
                        <span>{tour.duration_in_hours} hours</span>
                    </div>
                </div>
            </div>
            
            {tour.tourguide && (
                <div className="tourguide-info mt-4 p-4 bg-light rounded">
                    <h4 className="mb-3">By {tour.tourguide.name}</h4>
                    <div className="contact-details">
                        {tour.tourguide.email && (
                            <div className="mb-2">
                                <i className="bi bi-envelope me-2"></i>
                                <a href={`mailto:${tour.tourguide.email}`}>{tour.tourguide.email}</a>
                            </div>
                        )}
                        {tour.tourguide.phone && (
                            <div className="mb-2">
                                <i className="bi bi-telephone me-2"></i>
                                <a href={`tel:${tour.tourguide.phone}`}>{tour.tourguide.phone}</a>
                            </div>
                        )}
                        {tour.tourguide.webpage && (
                            <div className="mb-2">
                                <i className="bi bi-globe me-2"></i>
                                <a href={tour.tourguide.webpage} target="_blank" rel="noopener noreferrer">
                                    {tour.tourguide.webpage}
                                </a>
                            </div>
                        )}
                    </div>
                    <div className="social-links mt-3 d-flex gap-3">
                        {tour.tourguide.facebook && (
                            <a href={tour.tourguide.facebook} target="_blank" rel="noopener noreferrer">
                                <i className="bi bi-facebook" style={{ fontSize: '1.25rem' }}></i>
                            </a>
                        )}
                        {tour.tourguide.instagram && (
                            <a href={tour.tourguide.instagram} target="_blank" rel="noopener noreferrer">
                                <i className="bi bi-instagram" style={{ fontSize: '1.25rem' }}></i>
                            </a>
                        )}
                        {tour.tourguide.tiktok && (
                            <a href={tour.tourguide.tiktok} target="_blank" rel="noopener noreferrer">
                                <i className="bi bi-tiktok" style={{ fontSize: '1.25rem' }}></i>
                            </a>
                        )}
                    </div>
                </div>
            )}
        </div>
    )
}

export default DisplayTour
